import { render, staticRenderFns } from "./WebsiteDomainChecker.vue?vue&type=template&id=1394d6f5&scoped=true"
import script from "./WebsiteDomainChecker.vue?vue&type=script&lang=ts"
export * from "./WebsiteDomainChecker.vue?vue&type=script&lang=ts"
import style0 from "./WebsiteDomainChecker.vue?vue&type=style&index=0&id=1394d6f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1394d6f5",
  null
  
)

export default component.exports